import React, { memo } from 'react';

import { Typography } from '../material-ui/Typography';
import { useStyles } from './useStyles';

export const Message = memo(({ text }) => {
    const classes = useStyles();

    return (
        <div className={classes.wrapper}>
            <Typography className={classes.text}>{text}</Typography>
        </div>
    );
});

Message.displayName = 'Message';
